import { render } from "./RecentInstagramFollowers.vue?vue&type=template&id=cf22b21e&scoped=true&ts=true"
import script from "./RecentInstagramFollowers.vue?vue&type=script&lang=ts"
export * from "./RecentInstagramFollowers.vue?vue&type=script&lang=ts"

import "./RecentInstagramFollowers.vue?vue&type=style&index=0&id=cf22b21e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf22b21e"]])

export default __exports__